module.exports = __webpack_public_path__ + "img/gerch-contact.e75e95f5.jpg";